import { Popup } from '../../../components/Popup'
import { useContractDetailsPopup } from '../Providers/ContractDetailsPopupProvider'
import { Typography } from '../../../components/Typography'
import { Button, BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import { useCallback, useEffect, useState } from 'react'
import { TextArea } from '../../../components/Input/input.textarea'
import { TNote } from '../types'
import './styles.scss'

type ViewNotePopupProps = {
  note: TNote | null
  updateContractNote: (text: string) => void
  title: string
  subtitle: string
}

export const ViewNotePopup = ({
  note,
  updateContractNote,
  title,
  subtitle
}: ViewNotePopupProps) => {
  const {
    addNotePopup: {
      state,
      actions: { close }
    }
  } = useContractDetailsPopup()

  const [editableNote, setEditableNote] = useState<string | null>(null)

  const onSaveNote = useCallback(() => {
    updateContractNote(editableNote ?? '')
  }, [editableNote, updateContractNote])

  const onClose = useCallback(() => {
    setEditableNote(note?.text ?? '')
    close()
  }, [note, close])

  useEffect(() => {
    setEditableNote(note?.text ?? '')
  }, [note])

  return (
    <Popup
      {...state}
      title={title}
      onCancel={onClose}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={onClose} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} onClick={onSaveNote} upperCase>
            {BTN_TXT.SAVE}
          </Button>
        </>
      }
    >
      <div
        className="view-note-popup__content"
        onChange={(e) => e.stopPropagation()}
      >
        <div className="column gap-12">
          <Typography.Caption className="view-note-popup__content__caption">
            {subtitle}
          </Typography.Caption>
          <TextArea
            propsTextArea={{
              onChange: (e) => setEditableNote(e.target.value),
              value: editableNote ?? '',
              maxLength: 255
            }}
          />
        </div>
      </div>
    </Popup>
  )
}
